module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_long__square.f96f452e.png";